/**
 * Created by Administrador on 28/07/2016.
 */

(function(){
    'use strict';

    angular.module('completeAir')
        .factory('itineraryConnectionService', itineraryConnectionService);

    itineraryConnectionService.$inject = ['$http', 'CONFIG', 'messageService'];

    function itineraryConnectionService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/connectionItinerary';

        var service = {
            saveItineraryConnection: saveItineraryConnection,
            generatePreviewConnection: generatePreviewConnection,
            getItineraryConnections: getItineraryConnections,
            getItineraryConnection: getItineraryConnection,
            updateItineraryConnection: updateItineraryConnection,
            deleteConnectionItinerary: deleteConnectionItinerary,
            updateSegmentClassItineraries: updateSegmentClassItineraries
        };

        return service;

        function saveItineraryConnection(itineraryConnection){
            return $http.post(urlBase, itineraryConnection)
                .then(saveComplete)
                .catch(getFailed);

            function saveComplete(){
                messageService.register('');
            }
            function getFailed(){
                messageService.registerError('');
            }
        }

        function generatePreviewConnection(itineraryId,origin,destiny,minimumStay,maximumStay,maximumStop){
            return $http.get(urlBase + '/generate/' + itineraryId+'_'+origin+'_'+destiny+'_'+minimumStay+'_'+maximumStay+'_'+maximumStop)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response){
                return response.data;
            }
            function getFailed(){
                messageService.findAllError('');
            }
        }

        function getItineraryConnections(itineraryId, page, size){
            return $http.get(urlBase + '/page/'+itineraryId+'/itinerary?detailed=true&page=' + page + '&size=' + size)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response){
                //return (response.data._embedded) ? response.data._embedded.connectionsItinerary : [];
                return response;
            }
            function getFailed(){
                messageService.findAllError('');
            }
        }

        function getItineraryConnection(itineraryConnectionId){
            return $http.get(urlBase + '/'+itineraryConnectionId)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response){
                return (response.data) ? response.data : [];
            }
            function getFailed(){
                messageService.findAllError('');
            }
        }

        function updateItineraryConnection(itineraryConnectionId, itineraryConnection){
            return $http.put(urlBase + "/" + itineraryConnectionId, itineraryConnection)
                .then(saveComplete)
                .catch(getFailed);

            function saveComplete(){
                messageService.registerUpdate('');
            }
            function getFailed(){
                messageService.registerUpdateError();
            }
        }

        function deleteConnectionItinerary(itineraryConnectionId){
            return $http.delete(urlBase + '/' + itineraryConnectionId)
                .then(function(){
                    messageService.registerDelete('');
                })
                .catch(function(){
                    messageService.registerDeleteError('');
                });
        }

        function updateSegmentClassItineraries(segmentClasses){
            return $http.put(urlBase + "/plan" , segmentClasses)
                .then(function(response){
                    messageService.registerUpdate('');
                    return "ok";
                })
                .catch(function(error){
                    messageService.registerUpdateError('');
                    return "error";
                });
        }
    }
})();
